import { render } from "./VideoTemplate.vue?vue&type=template&id=0744cea9&scoped=true"
import script from "./VideoTemplate.vue?vue&type=script&lang=js"
export * from "./VideoTemplate.vue?vue&type=script&lang=js"

import "./VideoTemplate.vue?vue&type=style&index=0&id=0744cea9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0744cea9"]])

export default __exports__